var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTuteclassLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 192,
    height: 192,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#9fa19f",
    d: "M91.5-.5h9a36.7 36.7 0 0 0 7 4 9.1 9.1 0 0 0-5 1q-.355-1.12-1-2.5a55.4 55.4 0 0 0-16 .5 23.3 23.3 0 0 1 6-3",
    style: {
      opacity: 0.58
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7c8c7",
    d: "M108.5 3.5q2.48.24 4 2-2.82.406-4-2",
    style: {
      opacity: 0.329
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b3b4b3",
    d: "M112.5 5.5q3.978-.136 7 2-4.092.495-7-2",
    style: {
      opacity: 0.216
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b3b2",
    d: "M119.5 7.5a166 166 0 0 1 21 8 61.2 61.2 0 0 1-15.5-5q-2.407.9-4 3-.76-2.244 1.5-3.5-2.163-.565-3-2.5",
    style: {
      opacity: 0.302
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505251",
    d: "M107.5 3.5h1q1.18 2.406 4 2 2.908 2.495 7 2 .837 1.935 3 2.5-2.26 1.256-1.5 3.5 1.593-2.1 4-3a61.2 61.2 0 0 0 15.5 5l2 2q-.893 3.92-2.5 0a4.93 4.93 0 0 0-.5 3 44 44 0 0 1-2-1 13 13 0 0 1-4 4.5q2.01 3.224-2 3.5-.975.456-2 1a49.4 49.4 0 0 0-10-5q1.286-1.953 1.5-4-4.014 1.608-7-2-8.38 2.576-17.5.5-2.625-4.74-5 .5-4.783-3.052-9.5 1-3.136-1.935-4 2-2.59-1.614-5.5-.5-4.68 3.463-11 7-7.252 9.875-18 13 .912 1.305 2.5 1.5 5.037-1.111 9-4 2.63 4.365-1.5 8 1.783 1.393 4 1 4.892 1.415 9.5 6 3.136-1.936 4 2l1-2a457 457 0 0 1 4 3 3.94 3.94 0 0 1 2-1q3.885 1.84 7.5 1.5 2 1.5 0 3a52.6 52.6 0 0 1-7 1.5v3q12.528-.416 24 4l-2 2q-2.466-.32-4.5 1l-1-3q-3.362 5.109-8.5 1.5a856 856 0 0 0-72-30q-2.874-3.135-6-5.5a34.4 34.4 0 0 1 8-6q3.522-2.395 8-3 5.962.02 10-4a599 599 0 0 1 51-19 55.4 55.4 0 0 1 16-.5q.645 1.38 1 2.5a9.1 9.1 0 0 1 5-1",
    style: {
      opacity: 0.999
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#535554",
    d: "M142.5 17.5q4.212 2.144 9 2a240 240 0 0 1 25 9q3.18 2.098 6 5a232887 232887 0 0 0-80 35q-11.472-4.416-24-4v-3a52.6 52.6 0 0 0 7-1.5q2-1.5 0-3-3.615.34-7.5-1.5a3.94 3.94 0 0 0-2 1 457 457 0 0 0-4-3l-1 2q-.864-3.936-4-2-4.608-4.585-9.5-6 6.75-8.472 14 1.5 3.065.96 5-1.5 5.955-1.606 12 .5l-6 6q4.66-1.597 8-6 2.45-.74 5-.5 15.015 2.558 29-4.5 8.374-7.182-1-12.5-3.414-3.126-8-4.5 1.456-2.222 4-2.5a49.4 49.4 0 0 1 10 5q1.025-.544 2-1 1.837 2.924-2 4l.5 1 6 2q2.779-2.594-.5-3.5l3-1q-2.305-1.665-2-4.5 6.564.919 2-3.5.834-.575 1-1.5a4.93 4.93 0 0 1 .5-3q1.607 3.92 2.5 0",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b3b2",
    d: "M140.5 15.5q5.878 1.33 11 4-4.788.144-9-2z",
    style: {
      opacity: 0.671
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#939494",
    d: "M34.5 21.5q-4.038 4.02-10 4 4.527-2.85 10-4",
    style: {
      opacity: 0.718
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5f615f",
    d: "M119.5 23.5q-2.544.278-4 2.5 4.586 1.374 8 4.5 5.917 5.755 0 11.5-13.254 6.3-28 5.5-.627-1.083-2-1.5l5.5-5.5q2.26 1.552 4.5-.5l-2-2q5.459.417 11 0l-8-2 4-4q-3.89.82-6.5 4.5-2.034-1.32-4.5-1 .24 2.55-.5 5-1.512.723-3.5.5 1.39 4.158-3.5 4.5l-2.5-.5q2.115-.552 3-2.5a18.5 18.5 0 0 1-5-4q-1.87-2.313 0-4.5a4.93 4.93 0 0 0-3-.5q.092-3.138 3-4.5-3.52.118-6.5 2.5-3.6-1.653-7.5-.5 9.708.618 3 7 3.315 2.58 6 6-3.615.086-4 3.5-1.935 2.46-5 1.5-7.25-9.972-14-1.5-2.217.393-4-1 4.13-3.635 1.5-8-3.963 2.889-9 4-1.588-.195-2.5-1.5 10.748-3.125 18-13 6.32-3.537 11-7 2.91-1.114 5.5.5.864-3.935 4-2 4.717-4.052 9.5-1 2.375-5.24 5-.5 9.12 2.076 17.5-.5 2.986 3.608 7 2-.214 2.047-1.5 4",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#737574",
    d: "M139.5 20.5q-.166.925-1 1.5 4.564 4.419-2 3.5-.305 2.835 2 4.5l-3 1q3.279.906.5 3.5l-6-2-.5-1q3.837-1.076 2-4 4.01-.276 2-3.5a13 13 0 0 0 4-4.5q1.025.544 2 1",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a4a7a4",
    d: "M16.5 28.5a34.4 34.4 0 0 0-8 6l-5 4q3.942-8.232 13-10",
    style: {
      opacity: 0.635
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a2a7a3",
    d: "M176.5 28.5q6.708.712 9 7l-3-2q-2.82-2.902-6-5",
    style: {
      opacity: 0.925
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6e706f",
    d: "M95.5 47.5q-2.55-.24-5 .5-3.34 4.403-8 6l6-6q-6.045-2.105-12-.5.385-3.414 4-3.5a34.8 34.8 0 0 0-6-6q6.708-6.382-3-7 3.9-1.153 7.5.5 2.98-2.382 6.5-2.5-2.908 1.362-3 4.5a4.93 4.93 0 0 1 3 .5q-1.87 2.187 0 4.5a18.5 18.5 0 0 0 5 4q-.885 1.948-3 2.5l2.5.5q4.89-.342 3.5-4.5 1.988.223 3.5-.5.74-2.45.5-5 2.466-.32 4.5 1 2.61-3.68 6.5-4.5l-4 4 8 2a73 73 0 0 1-11 0l2 2q-2.24 2.052-4.5.5L93.5 46q1.373.417 2 1.5",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151615",
    d: "M182.5 33.5q.822 2.84 3 5a1784 1784 0 0 0-83.5 33q-1.148-.105-1.5-1l2-2a232887 232887 0 0 1 80-35",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8e908f",
    d: "M123.5 30.5q9.374 5.318 1 12.5-13.985 7.058-29 4.5 14.746.8 28-5.5 5.917-5.745 0-11.5",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f201f",
    d: "m182.5 33.5 3 2q2.919.802 3 4a29.1 29.1 0 0 1 .5 9 129 129 0 0 1-9.5 5 54.3 54.3 0 0 1-4-9 11.4 11.4 0 0 0-2 2.5q3.311 2.688 4 7a36.2 36.2 0 0 1-7 4q3.254.645 6-1.5a86.6 86.6 0 0 1 1.5 13l1-14a35.3 35.3 0 0 1 11.5-5 145 145 0 0 1-.5 17q-1.665 2.306-4.5 2-.329 1.762 1 3 1.68-2 4-1.5a2391 2391 0 0 0-11 9.5q-1.911-1.035 0-2.5-7.318-.167-1-3.5 2.97 1.325 6-.5a6.8 6.8 0 0 1-3-1.5 39 39 0 0 1 5-5.5l-1-.5a308 308 0 0 1-12.5 11q-.738 1.574.5 3a246 246 0 0 0-7 2 29.4 29.4 0 0 0-7 2 2.43 2.43 0 0 1-2-.5q1.794-.981 0-1.5a26.5 26.5 0 0 0-6.5 3 3.94 3.94 0 0 1-2-1q.53-6.117 3-12 1.371 5.528 2-1l5 5 .5-1a96 96 0 0 1-7.5-9l-3 11q-.315-2.337-1.5-4a54.5 54.5 0 0 0-11 4 34 34 0 0 0-2 7 692 692 0 0 0-7 4 23.6 23.6 0 0 0-3-3.5q5.751-3.4-1-2 1.701-1.524-1-2 1.846-1.775 0-3.5a3.65 3.65 0 0 0-1.5 1q.159 5.71-.5 11-1.983.255-3.5-1-2.234 1.386-.5 3a51 51 0 0 0 6-2q-2.116-2.275.5-4 .41 2.743 2.5 4.5-3.514 1.509-4.5 4.5a90 90 0 0 1 7.5-5q1.536 2.03 4 2-.954 3.442-4 5a16.3 16.3 0 0 0-5 2q-4.765 2.53-5.5 8l-5 6a28 28 0 0 0-1.5-4 69 69 0 0 1 6-3.5q-2.061-4.349-4.5-.5l-1-1q-6.316 4.149-13.5 7.5l3 1q-2.39 1.423-4 3.5v13q.342 25.012 1 49a95 95 0 0 1 18 1.5q-.834.575-1 1.5-6.168 1.833-11 6a71 71 0 0 1-2-4l-3 1.5a29 29 0 0 1 4 5l-3 1.5a66 66 0 0 0-10-1.5q3.446-3.149 5-7.5 1.098-4.148 0-8v-10a199 199 0 0 0-1-27v-21a96.3 96.3 0 0 0-1-19q1.262-2.82 1-6 .768-5.302 0-10-1.007-2.02 0-3.5a20.5 20.5 0 0 0-3.5-2.5l1 5a21.5 21.5 0 0 0-6-5 4.93 4.93 0 0 1-.5-3h-3a918 918 0 0 0-63-26q-2.65-1.725-3.5 2-1.046-3.126-3.5-5a20.7 20.7 0 0 0-5-1 9.17 9.17 0 0 0-4.5 2q.028-2.411.5-5l5-4q3.126 2.365 6 5.5a856 856 0 0 1 72 30q5.138 3.609 8.5-1.5l1 3q2.034-1.32 4.5-1 .352.895 1.5 1a1784 1784 0 0 1 83.5-33q-2.178-2.16-3-5",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#575857",
    d: "M12.5 42.5q2.454 1.874 3.5 5 .85-3.725 3.5-2 3.384 1.475 5 5-1.79 2.826-5 1.5-6.145-2.883-7-9.5",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#303231",
    d: "M7.5 41.5q2.574.193 5 1 .855 6.617 7 9.5 3.21 1.326 5-1.5-1.616-3.525-5-5a918 918 0 0 1 63 26q-4.945-.257-1 2a3.65 3.65 0 0 1-1 1.5q-5.595-.36-8 4.5a17 17 0 0 1 3.5 8l1-2q4.422 2.315 2.5 6.5 2.952 3.164 6.5 2.5 2.245 1.466 4.5 3a10 10 0 0 0 3-1 96.3 96.3 0 0 1 1 19l-8-4-4.5-9a69.2 69.2 0 0 0-13-9Q65.75 80.25 52.5 77a93 93 0 0 0-5.5-9.5q-.575.835-1.5 1-3.08.147-5-2 2.588-.514 1.5-3a16.6 16.6 0 0 0-5-6 430 430 0 0 0-19.5 4q-1.45-1.96-4-2-.495 4.092 2 7l1 6q-3.678.186-6 3-3.392-.893-5-4v-3q-4.121-.147-2 3 .426 2.872-1 5-1.838-.978-2-3.5-.404-14.082 1-28.5 4.23.62 6-3",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#949694",
    d: "M3.5 38.5a30 30 0 0 0-.5 5 9.17 9.17 0 0 1 4.5-2q-1.77 3.62-6 3A227 227 0 0 0 .5 73q.162 2.522 2 3.5-1.99 2.542 1 4-.607 1.575-2 0-1.906 3.459 1 6h-3v-42z",
    style: {
      opacity: 0.424
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b6c6b",
    d: "M40.5 66.5q-2.818.16-1-1.5-2.47-5.785-7-2.5-7.269-3.462-15-1a430 430 0 0 1 19.5-4q3.2 2.385 5 6 1.088 2.486-1.5 3",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#787a79",
    d: "M17.5 61.5q-2.202 1.92-2 5-2.495-2.908-2-7 2.55.04 4 2",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c0c1c0",
    d: "M5.5 68.5q-.393-2.217 1-4 2.417 1.23 2 4z",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M5.5 68.5v3h-2q-2.121-3.147 2-3",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#686a69",
    d: "M16.5 74.5q-.482 2.322-3 2-.71 5.486-4 .5-2.5-1-5 0a12 12 0 0 1-1 3.5q-2.99-1.458-1-4 1.426-2.128 1-5h2q1.608 3.107 5 4 2.322-2.814 6-3l-1-6q1.475 3.383 5 5l1-1.5q-1.672-2.09-1.5-4.5a3.94 3.94 0 0 0 2 1 240 240 0 0 0 10.5-3q.06 2.788-2.5 4-1.676-.247-3.5-1-1.948.885-2.5 3l-1-2q-1 3 0 6 2.138 1.068 4.5.5-6.24 5.502-9.5-2.5z",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#79dedb",
    d: "M147.5 73.5a57.2 57.2 0 0 0 1 15 83 83 0 0 0 11-4 29.4 29.4 0 0 1 7-2q1.79.705 2 3 .12 4.365-4 5a142 142 0 0 0-17.5 6 242 242 0 0 0-.5 22v1q-1.995 9.455 0 19 3.91 1.728 8 .5a122 122 0 0 1 8-6.5l4 2q2.457 1.807 1 4-9.132 12.067-24 15-3.512.205-6-2-.5-1.5-2-2-.24-2.48-2-4-.642-12.993-1-26v-18q-1.936-.356-3 1-1.488-.257-2 1h-3q-.393-2.217 1-4 2.032-1.032 3-3 3.046-1.558 4-5a21.2 21.2 0 0 0 2-7 34 34 0 0 1 2-7 54.5 54.5 0 0 1 11-4",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#575857",
    d: "M82.5 71.5h3a4.93 4.93 0 0 0 .5 3 21.5 21.5 0 0 1 6 5l-1-5a20.5 20.5 0 0 1 3.5 2.5q-1.007 1.48 0 3.5a4.93 4.93 0 0 1-.5 3q-4.433-7.095-12.5-5.5-2.847 15.4 13 12.5.262 3.18-1 6-1.374.723-3 1a283 283 0 0 0-4.5-3q-3.548.664-6.5-2.5 1.922-4.185-2.5-6.5l-1 2a17 17 0 0 0-3.5-8q2.405-4.86 8-4.5.685-.621 1-1.5-3.945-2.257 1-2",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#686968",
    d: "m188.5 39.5 3 4v45a3090 3090 0 0 1-3 41 93.6 93.6 0 0 0-2-26 22.8 22.8 0 0 0 2-5.5l-1-2.5q-3.607 3.744-7-.5a168 168 0 0 1 8-1.5 69.3 69.3 0 0 0 .5-19 90.5 90.5 0 0 1-9.5 7v-1q5.453-4.739 11-9.5-2.32-.5-4 1.5-1.329-1.238-1-3 2.835.306 4.5-2a145 145 0 0 0 .5-17 35.3 35.3 0 0 0-11.5 5l-1 14a86.6 86.6 0 0 0-1.5-13q-2.746 2.145-6 1.5a36.2 36.2 0 0 0 7-4q-.689-4.312-4-7a11.4 11.4 0 0 1 2-2.5 54.3 54.3 0 0 0 4 9 129 129 0 0 0 9.5-5 29.1 29.1 0 0 0-.5-9",
    style: {
      opacity: 0.996
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c2d2c",
    d: "M94.5 80.5q.768 4.698 0 10-15.847 2.9-13-12.5 8.067-1.595 12.5 5.5.725-1.422.5-3",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4f5150",
    d: "M16.5 74.5a30 30 0 0 0 3 3.5 502 502 0 0 1 21 3.5 8.43 8.43 0 0 0-4 .5q3.112 4.587 4 10-4.713-.132-7.5-4.5-1.675 2.436-4.5 3a28.8 28.8 0 0 0-7-2v-4q-3.334.483-5.5-2-1.462 3.567-2-1-2.652 1.773-.5 4-2.705-.114-6 1-.822-3.048-4-3v3h-1q-2.906-2.541-1-6 1.393 1.575 2 0a12 12 0 0 0 1-3.5q2.5-1 5 0 3.29 4.986 4-.5 2.518.322 3-2",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d7d7d7",
    d: "M85.5 82.5q4.5-.5 4 4-4.5.5-4-4",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3e4140",
    d: "M179.5 80.5v1q.531 3.061 0 5.5-2.32.5-4-1.5l-8 6a5.6 5.6 0 0 0-3-1q4.12-.635 4-5-.21-2.295-2-3a246 246 0 0 1 7-2q-1.238-1.426-.5-3a308 308 0 0 0 12.5-11l1 .5a39 39 0 0 0-5 5.5 6.8 6.8 0 0 0 3 1.5q-3.03 1.825-6 .5-6.318 3.333 1 3.5-1.911 1.465 0 2.5",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4f5554",
    d: "M159.5 84.5a83 83 0 0 1-11 4 57.2 57.2 0 0 1-1-15q1.185 1.663 1.5 4l3-11a96 96 0 0 0 7.5 9l-.5 1-5-5q-.629 6.528-2 1-2.47 5.883-3 12a3.94 3.94 0 0 0 2 1 26.5 26.5 0 0 1 6.5-3q1.794.519 0 1.5a2.43 2.43 0 0 0 2 .5",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7f807f",
    d: "M7.5 86.5q-2.46.97-4 3v-6q3.178-.048 4 3",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8e8d",
    d: "M13.5 85.5q-.333 4.335 2 8l-1.5 1q-2.426-4.558-6.5-8 3.295-1.114 6-1",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#747574",
    d: "M94.5 115.5v8q-1.437.679-2.5 2a84.3 84.3 0 0 1-8.5-12.5q-5.568-1.84-10-5.5-4.568-5.153-6.5-12-12.672-3.355-16-16a1379 1379 0 0 1-9-5l-.5-1.5a25.5 25.5 0 0 0 4-4.5q.925-.165 1.5-1a93 93 0 0 1 5.5 9.5Q65.75 80.25 69 93.5a69.2 69.2 0 0 1 13 9l4.5 9z",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    d: "M-.5 86.5h4v3a11.8 11.8 0 0 1 2 3.5q-.525 1.885-2 1A24.4 24.4 0 0 0 1 88.5a32.4 32.4 0 0 0-.5 8h-1z",
    style: {
      opacity: 0.028
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ddd",
    d: "M20.5 90.5h3q.147 4.122-3 2z",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#606260",
    d: "M21.5 84.5v4a28.8 28.8 0 0 1 7 2q2.825-.564 4.5-3 2.787 4.368 7.5 4.5-.888-5.413-4-10a8.43 8.43 0 0 1 4-.5h5q-1.245 8.331 6 12a3.65 3.65 0 0 1-1 1.5q9.747 6.78 3 16 1.374.417 2 1.5.276 4.01 3.5 2 .648 1.65-1.5 2a53.5 53.5 0 0 0-10-2v-5q-10.033-1.786-9.5-12-8.64-8.313-2.5 1.5a8.43 8.43 0 0 1-4 .5q.303 3.734-1.5 7-3.58-3.588-6.5 1-1.407-6.375 0-12.5-2.349-.45-4 1.5v-3q1 0 1-1 3.147 2.122 3-2h-3q.24-2.55-.5-5l-1 2q-2.166-2.483-5.5-2-2.152-2.227.5-4 .538 4.567 2 1 2.166 2.483 5.5 2",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c4c5c4",
    d: "M21.5 84.5v-3h3v3z",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4e504f",
    d: "M134.5 84.5a21.2 21.2 0 0 1-2 7q-2.464.03-4-2a90 90 0 0 0-7.5 5q.986-2.991 4.5-4.5-2.09-1.757-2.5-4.5-2.616 1.725-.5 4a51 51 0 0 1-6 2q-1.734-1.614.5-3 1.517 1.255 3.5 1 .659-5.29.5-11 .621-.685 1.5-1 1.846 1.725 0 3.5 2.701.476 1 2 6.751-1.4 1 2a23.6 23.6 0 0 1 3 3.5 692 692 0 0 1 7-4",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dbdbdb",
    d: "M19.5 93.5v3q-5.715-1.881 0-3",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#474947",
    d: "M40.5 66.5q1.92 2.147 5 2a25.5 25.5 0 0 1-4 4.5l.5 1.5q4.446 2.492 9 5 3.328 12.645 16 16 1.932 6.847 6.5 12-1.356 1.064-1 3-.96-2.314-3-4-3.42 2.739 0 6l-1 1q-3.198-3.37-3-7-1.677 6.206 3 11a4.94 4.94 0 0 1-1 2.5q3.05 4.136 7.5 6.5 2.61-3.959 1.5-8 1.792.549 2 2.5-.597 3.506 0 7.5a8.4 8.4 0 0 1 4 .5 105 105 0 0 0 12 7.5 199 199 0 0 1 1 27q-2.322-.481-2-3-1.936.356-3-1 2.292-1.953 3-5 1.47-4.687 1-10-3.265-.13-6-2a4.45 4.45 0 0 0-1.5 2l-5-5q-1 6-2 0-.575.834-1.5 1-3.336-2.355-5.5-8-1.517-1.255-3.5-1-.087 4.746-2 9a267 267 0 0 0-26-1.5q5.064 4.869 5.5 11.5-2.289-7.69-3 0-.724-4.985-4.5-8l-1 .5q3.838 1.985 2 5.5a416 416 0 0 1-4-7q-.16-2.818 1.5-1 4.646-1.184.5-3.5a4.94 4.94 0 0 0 1-2.5 28.8 28.8 0 0 1-2-7l8 2q-.245 3.535.5 7 2.26 1.552 4.5-.5-1.595-1.782-4-1.5.066-5.385 5-7.5-11.348-3.887-.5-8.5a28.3 28.3 0 0 1 9 3q1.282 4.36-2.5 7a54.4 54.4 0 0 1 6.5 6q-.6-3.901-4.5-6 3.442-5.126 1-11 1.208-2.958 4-4.5a19.9 19.9 0 0 0-4-3.5q-.867 4.942-5 3-.626-1.083-2-1.5 6.747-9.22-3-16 .685-.621 1-1.5-7.245-3.669-6-12h-5a502 502 0 0 0-21-3.5 30 30 0 0 1-3-3.5l1.5-3q3.26 8.002 9.5 2.5-2.362.568-4.5-.5-1-3 0-6l1 2q.552-2.115 2.5-3 1.824.753 3.5 1 2.56-1.212 2.5-4a240 240 0 0 1-10.5 3 3.94 3.94 0 0 1-2-1q-.172 2.41 1.5 4.5l-1 1.5q-3.525-1.617-5-5-.202-3.08 2-5 7.731-2.462 15 1 4.53-3.285 7 2.5-1.818 1.66 1 1.5",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#353736",
    d: "M164.5 90.5q-.166.925-1 1.5a33 33 0 0 1 6 9l2 .5a40 40 0 0 1 7.5-5q.561 1.374 1.5 2.5a4407 4407 0 0 1-8.5 5.5 4.46 4.46 0 0 0-1.5-2q-2 5.5 0 11 8.164-7.48 11.5 3 1.03-3.102-.5-6 .519-1.794 1.5 0a45.9 45.9 0 0 1 1.5 15 808 808 0 0 0-9 6 16.1 16.1 0 0 0-5 2q-1.794-.519 0-1.5-4.261 1.518-4-3.5 7.14.151 4.5-6a22.8 22.8 0 0 0-4 5q-2.158-4.69-2.5-9l-1 2.5a494 494 0 0 1 3 13.5l-4-2a122 122 0 0 0-8 6.5q-4.09 1.228-8-.5-1.995-9.545 0-19 3.027-1.685 6 0 2.07-4.227-.5-8a17.7 17.7 0 0 0 .5 6q-3.182-.262-6 1-.25-11.011.5-22a142 142 0 0 1 17.5-6",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5b5a",
    d: "M102.5 85.5q1.875.116 2.5 2 2.549 9.625-5 16-3.723-2.865-1.5-7 3.517 4.082 5.5-1 1.264-5.404-1.5-10",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#555e5d",
    d: "M128.5 96.5q-.968 1.968-3 3-1.393 1.783-1 4h3q-1.936 1.46 0 3a6.55 6.55 0 0 1-3 3 31.1 31.1 0 0 1-1-11 16.3 16.3 0 0 1 5-2",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#545554",
    d: "M111.5 108.5a27.2 27.2 0 0 0-6 3.5q2.157.328 4 1.5a11.5 11.5 0 0 0-5 3.5q-3.264.244-5.5 2.5-1-1 0-2 10.85-6.335-1.5-2 1.61-2.077 4-3.5l-3-1q7.184-3.351 13.5-7.5l1 1q2.439-3.849 4.5.5a69 69 0 0 0-6 3.5",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#747674",
    d: "M146.5 119.5v-1q2.818-1.262 6-1a17.7 17.7 0 0 1-.5-6q2.57 3.773.5 8-2.973-1.685-6 0",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#353735",
    d: "M73.5 107.5q4.432 3.66 10 5.5a84.3 84.3 0 0 0 8.5 12.5q1.063-1.321 2.5-2v13a105 105 0 0 1-12-7.5 8.4 8.4 0 0 0-4-.5q-.597-3.994 0-7.5-.208-1.951-2-2.5-1.647-1.345 0-2.5a9.5 9.5 0 0 1-2.5-1.5q-.315-2.337-1.5-4-.356-1.936 1-3",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#696b6a",
    d: "M72.5 110.5q1.185 1.663 1.5 4a9.5 9.5 0 0 0 2.5 1.5q-1.647 1.155 0 2.5 1.11 4.041-1.5 8-4.45-2.364-7.5-6.5a4.94 4.94 0 0 0 1-2.5q-4.677-4.794-3-11-.198 3.63 3 7l1-1q-3.42-3.261 0-6 2.04 1.686 3 4",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#252625",
    d: "M188.5 129.5v7a23.3 23.3 0 0 1-3 7 31.7 31.7 0 0 0-6 2l-1-2a3.65 3.65 0 0 0-1.5 1q1.884 4.612 2.5 10a229 229 0 0 1-16 8 8.4 8.4 0 0 1-4-.5q.52-2.353.5-5.5l-2.5 2.5q-.443 2.57 1 5.5-3.207-.305-5-3l-1 1q3.888 2.617 0 5-5.893 4.14-13 6a18.5 18.5 0 0 1-6-.5l2-1q-1.426-4.585-1-9.5-6.22.18-2 4.5-1.792 2.3 0 4.5-1.918 2.47-5 3.5l3 1q-1.129 1.006-1 2.5a164.4 164.4 0 0 1-22 10q-1.815-.648-3-2 4.832-4.167 11-6l7-3.5a288 288 0 0 1-23.5-1.5 2.43 2.43 0 0 0-.5 2 3570 3570 0 0 1-1-49q1.09 11.775 2 24l1 2q1.683-1.695 4-2 1.345-1.647 2.5 0l1 7q.747-4.473.5-9 1.485-8.715 1-18h5q-.356 1.936 1 3a9.1 9.1 0 0 1-1 5 22.1 22.1 0 0 1 2.5 9q2.826 3.114 6.5 1a68.2 68.2 0 0 0 6.5-17q.575.834 1.5 1a89 89 0 0 0-.5 16q.149-3.229 2.5-5 1.76 1.52 2 4-3.003 5.732-7.5 8-1.517-1.255-3.5-1-.576 3.248 2 5 3.915.129 8-2 4.094-2.8-1-3-.196-4.3 4-5 2.488 2.205 6 2 14.868-2.933 24-15 5.553-2.355 11-2.5 1.58-2.082.5-4.5-1.937 1.936-3.5 0a808 808 0 0 1 9-6 45.9 45.9 0 0 0-1.5-15q-.981-1.794-1.5 0 1.53 2.898.5 6-3.336-10.48-11.5-3-2-5.5 0-11a4.46 4.46 0 0 1 1.5 2q4.241-2.737 8.5-5.5a9.5 9.5 0 0 1-1.5-2.5 40 40 0 0 0-7.5 5l-2-.5a33 33 0 0 0-6-9q.834-.575 1-1.5a5.6 5.6 0 0 1 3 1l8-6q1.68 2 4 1.5.531-2.439 0-5.5a90.5 90.5 0 0 0 9.5-7 69.3 69.3 0 0 1-.5 19q-3.999.65-8 1.5 3.393 4.244 7 .5l1 2.5a22.8 22.8 0 0 1-2 5.5 93.6 93.6 0 0 1 2 26",
    style: {
      opacity: 0.999
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#696c6a",
    d: "M55.5 112.5q4.133 1.942 5-3a19.9 19.9 0 0 1 4 3.5q-2.792 1.542-4 4.5 2.442 5.874-1 11 3.9 2.099 4.5 6a54.4 54.4 0 0 0-6.5-6q3.782-2.64 2.5-7a28.3 28.3 0 0 0-9-3q-10.848 4.613.5 8.5-4.934 2.115-5 7.5 2.405-.282 4 1.5-2.24 2.052-4.5.5a25 25 0 0 1-.5-7l-8-2a28.8 28.8 0 0 0 2 7 4.94 4.94 0 0 1-1 2.5q4.146 2.316-.5 3.5-1.66-1.818-1.5 1h-1a242 242 0 0 0-5-17 4.94 4.94 0 0 1 1-2.5q1.857.116 3-.5a690 690 0 0 0-8-3q2.379-1.74 6-.5a73 73 0 0 1-9-5.5q-1.92-2.522 0-5 2.92-4.588 6.5-1 1.803-3.266 1.5-7a8.43 8.43 0 0 0 4-.5q-6.14-9.813 2.5-1.5-.533 10.214 9.5 12v5a53.5 53.5 0 0 1 10 2q2.148-.35 1.5-2-3.223 2.01-3.5-2",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2b2c2b",
    d: "M123.5 98.5a31.1 31.1 0 0 0 1 11 6.55 6.55 0 0 0 3-3q-1.936-1.54 0-3 .512-1.257 2-1 1.95 2.585 2 6.5a22 22 0 0 1-1.5 8.5q-1.407-7.368-5.5-1l3 2q-1.214 3.438-1 6.5a19.9 19.9 0 0 1 1.5 9.5 6.55 6.55 0 0 0-3 3q-2.655-1.165-5.5.5.178 1.922-1.5 3.5a41.4 41.4 0 0 1-2.5-6q-.029-6.512-6-4a91 91 0 0 0-1 19q-1.983.255-3.5-1a4.93 4.93 0 0 0-.5 3q-2.317.305-4 2l-1-2q-.91-12.225-2-24v-13q12.35-4.335 1.5 2-1 1 0 2 2.236-2.256 5.5-2.5a11.5 11.5 0 0 1 5-3.5 10.3 10.3 0 0 0-4-1.5 27.2 27.2 0 0 1 6-3.5 28 28 0 0 1 1.5 4l5-6q.735-5.47 5.5-8",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#606261",
    d: "M175.5 131.5q1.563 1.936 3.5 0 1.08 2.418-.5 4.5-5.447.145-11 2.5 1.457-2.193-1-4a494 494 0 0 0-3-13.5l1-2.5q.342 4.31 2.5 9a22.8 22.8 0 0 1 4-5q2.64 6.151-4.5 6-.261 5.018 4 3.5-1.794.981 0 1.5a16.1 16.1 0 0 1 5-2",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#494b4a",
    d: "M13.5 85.5q3.334-.483 5.5 2l1-2q.74 2.45.5 5v2q0 1-1 1-5.715 1.119 0 3 1.651-1.95 4-1.5-1.407 6.125 0 12.5-1.92 2.478 0 5a73 73 0 0 0 9 5.5q-3.621-1.24-6 .5 4.015 1.477 8 3-1.143.616-3 .5a4.94 4.94 0 0 0-1 2.5 242 242 0 0 1 5 17q-2.751-1.491-5 0-2.675-1.012-5-1 2.18-1.53 1-3.5l2-1q-8.064-7.692-18-9.5a71 71 0 0 1-1.5 9q-.747 3.067-3.5 4-2.634-1.578-2-5-.353-10.281-2-20a86.8 86.8 0 0 1-1-18 32.4 32.4 0 0 1 .5-8A24.4 24.4 0 0 1 3.5 94q1.475.885 2-1a11.8 11.8 0 0 0-2-3.5q1.54-2.03 4-3 4.074 3.442 6.5 8l1.5-1q-2.333-3.665-2-8",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#797b7a",
    d: "M5.5 100.5q3.334-.483 5.5 2l5 11a30 30 0 0 1 7 6q2.75 9.25-6.5 6.5-4.959-3.341-4.5-9.5a52.2 52.2 0 0 0-7-10q-1.017-3.147.5-6",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d4f4e",
    d: "M13.5 113.5q4.54 3.044 7 8a4.45 4.45 0 0 1-1.5 2q-2.348.841-4-2a19 19 0 0 1-1.5-8",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c4c5c4",
    d: "M1.5 114.5q1.647 9.719 2 20h-1q-.927-9.663-1-20",
    style: {
      opacity: 0.71
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a7e7c",
    d: "M132.5 119.5q.358 13.007 1 26-2.351 1.771-2.5 5a89 89 0 0 1 .5-16q-1.157-7.591 1-15",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#606260",
    d: "M115.5 135.5q-1.356-1.064-1-3h-5q.485 9.285-1 18a91 91 0 0 1 1-19q5.971-2.512 6 4",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464847",
    d: "M129.5 102.5q1.064-1.356 3-1v18q-2.157 7.409-1 15-.925-.166-1.5-1a68.2 68.2 0 0 1-6.5 17q-3.674 2.114-6.5-1a22.1 22.1 0 0 0-2.5-9 9.1 9.1 0 0 0 1-5 41.4 41.4 0 0 0 2.5 6q1.678-1.578 1.5-3.5 2.845-1.665 5.5-.5a6.55 6.55 0 0 1 3-3 19.9 19.9 0 0 0-1.5-9.5q-.214-3.062 1-6.5l-3-2q4.093-6.368 5.5 1a22 22 0 0 0 1.5-8.5q-.05-3.915-2-6.5",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#939493",
    d: "M188.5 136.5q.512 5.49-2 10 .356-1.936-1-3a23.3 23.3 0 0 0 3-7",
    style: {
      opacity: 0.537
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#444544",
    d: "M185.5 143.5q1.356 1.064 1 3-1.39 5.888-7 8-.616-5.388-2.5-10a3.65 3.65 0 0 1 1.5-1l1 2a31.7 31.7 0 0 1 6-2",
    style: {
      opacity: 0.998
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7c7e7d",
    d: "M2.5 134.5h1q-.634 3.422 2 5a14.7 14.7 0 0 0-1 4.5q2.529 3.817 3 8.5-3.093-2.865-4.5-7a61 61 0 0 1-.5-11",
    style: {
      opacity: 0.341
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#303231",
    d: "M78.5 140.5q.925-.166 1.5-1 1 6 2 0l5 5a4.45 4.45 0 0 1 1.5-2q2.734 1.87 6 2 .47 5.313-1 10 .329-1.763-1-3-1.536 2.03-4 2 .338-3.324-2.5-5-1.066 2.8 1.5 4.5a6.8 6.8 0 0 0-3 1.5 9.4 9.4 0 0 1 3 3 6.85 6.85 0 0 0-1 4q2.55-.04 4-2 1.064 1.356 3 1-.322 2.519 2 3v10q-7.946.403-4 7 1.783 1.393 4 1-1.554 4.351-5 7.5 5.085.369 10 1.5l3-1.5a29 29 0 0 0-4-5l3-1.5a71 71 0 0 0 2 4q1.185 1.352 3 2a10.2 10.2 0 0 0-3 3h-17a82.7 82.7 0 0 1-19-9 128 128 0 0 1-1-12q3.4-.538 5.5 2 1.125-1.702-.5-3-2.739-.63-6 0 .402 3.928-1 7.5a7.25 7.25 0 0 1 2 2.5q-2.468 1.507-6 0a8.4 8.4 0 0 1-4-.5 177 177 0 0 0-8-4.5q-.68-1.437-2-2.5 5.04-1.262 7-6-2.86-.197-4.5 2.5a29 29 0 0 0-6-4q-.582 1.392-2 2-6.922-1.452-12-6l-1 1q-4.474-1.852-7.5-5.5a42.9 42.9 0 0 1 12-4.5v-3a177 177 0 0 0 18 7q.898 5.031 4 9 4.864.772 8.5 4 .76-2.244-1.5-3.5a100 100 0 0 1 2-5.5 6.85 6.85 0 0 0 4 1 52 52 0 0 1-1-7q3.824-.089 6 3l1-1.5a4404 4404 0 0 1-8-8h4l-6-4q2.915.458 6 0 3.93-1.3 5-3.5a10 10 0 0 1 3 1",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c2c3c2",
    d: "M93.5 154.5q-.708 3.047-3 5-1.45 1.96-4 2a6.85 6.85 0 0 1 1-4 9.4 9.4 0 0 0-3-3 6.8 6.8 0 0 1 3-1.5q-2.566-1.7-1.5-4.5 2.838 1.676 2.5 5 2.464.03 4-2 1.329 1.237 1 3",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636563",
    d: "M108.5 150.5a41 41 0 0 1-.5 9l-1-7q-1.155-1.647-2.5 0a4.93 4.93 0 0 1 .5-3q1.517 1.255 3.5 1",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3c3e3d",
    d: "M25.5 140.5q-2.941-.347-6 2a3.65 3.65 0 0 1-1.5-1q-1.159 2.023-3.5 2.5l2 1a73 73 0 0 0-4 7q4.085 2.003 8 .5.225-5.492-4.5-3-1-1 0-2 4.26-3.528 9.5-5 2.241.314 3.5 2l1-1q2.93 3.428-.5 6.5 2.957-.014 3-3.5-1.047-2.044 0-3.5-1.374-.417-2-1.5 2.249-1.491 5 0h1a416 416 0 0 0 4 7q1.838-3.515-2-5.5l1-.5q3.776 3.015 4.5 8 .711-7.69 3 0-.436-6.631-5.5-11.5 12.777.1 26 1.5 1.913-4.254 2-9 1.983-.255 3.5 1 2.164 5.645 5.5 8a10 10 0 0 0-3-1q-1.07 2.2-5 3.5-3.085.458-6 0l6 4h-4q3.987 3.998 8 8l-1 1.5q-2.176-3.089-6-3a52 52 0 0 0 1 7 6.85 6.85 0 0 1-4-1 100 100 0 0 0-2 5.5q2.26 1.256 1.5 3.5-3.636-3.228-8.5-4-3.102-3.969-4-9a177 177 0 0 1-18-7v3a42.9 42.9 0 0 0-12 4.5q3.026 3.648 7.5 5.5l1-1q5.078 4.548 12 6 1.418-.608 2-2a29 29 0 0 1 6 4q1.64-2.697 4.5-2.5-1.96 4.738-7 6 1.32 1.063 2 2.5-14.85-6.876-30-13.5-6.891-3.178-12-8.5-.471-4.683-3-8.5a14.7 14.7 0 0 1 1-4.5q2.753-.933 3.5-4a71 71 0 0 0 1.5-9q9.936 1.808 18 9.5l-2 1q1.18 1.97-1 3.5",
    style: {
      opacity: 0.997
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5e5f5e",
    d: "M25.5 140.5q2.325-.012 5 1 .626 1.083 2 1.5-1.047 1.456 0 3.5-.044 3.486-3 3.5 3.43-3.072.5-6.5l-1 1q-1.259-1.686-3.5-2-5.24 1.472-9.5 5-1 1 0 2 4.725-2.492 4.5 3-3.915 1.503-8-.5a73 73 0 0 1 4-7l-2-1q2.341-.477 3.5-2.5.621.686 1.5 1 3.059-2.347 6-2",
    style: {
      opacity: 0.996
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#434444",
    d: "M135.5 149.5q1.5.5 2 2-4.196.7-4 5 5.094.2 1 3-4.085 2.129-8 2-2.576-1.752-2-5 1.983-.255 3.5 1 4.497-2.268 7.5-8",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#535453",
    d: "M117.5 157.5q.814.09 1 1a605 605 0 0 1-3 3.5q.608 1.418 2 2l-1 1q2.551.517 4-2-1.982-2.317 1-3.5-.586 1.827 2 2.5a25 25 0 0 1-8 6.5 39 39 0 0 1-2-6.5 19.4 19.4 0 0 1 4-4.5",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5b5a",
    d: "M163.5 162.5q-1.92 2.147-5 2-1.443-2.93-1-5.5l2.5-2.5q.02 3.147-.5 5.5a8.4 8.4 0 0 0 4 .5",
    style: {
      opacity: 0.627
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5b5c5b",
    d: "M77.5 160.5q4.385.995 2 5-4.92-2.675-7.5 2a15.3 15.3 0 0 0-1.5-4.5l6-1q.835-.575 1-1.5",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#585858",
    d: "M158.5 164.5q-2.117 3.058-6 3 3.888-2.383 0-5l1-1q1.793 2.695 5 3",
    style: {
      opacity: 0.988
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#696b6a",
    d: "M68.5 182.5q-4.486.501-7-3 3.532 1.507 6 0a7.25 7.25 0 0 0-2-2.5q1.402-3.572 1-7.5 3.261-.63 6 0 1.625 1.298.5 3-2.1-2.538-5.5-2 .22 6.029 1 12",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4f504f",
    d: "M139.5 173.5q-4.302 3.618-10 5-.129-1.494 1-2.5l-3-1q3.082-1.03 5-3.5-1.792-2.2 0-4.5-4.22-4.32 2-4.5-.426 4.915 1 9.5l-2 1q2.96.743 6 .5",
    style: {
      opacity: 0.996
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#575757",
    d: "M95.5 173.5q1.098 3.852 0 8-2.217.393-4-1-3.946-6.597 4-7",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5d5e5d",
    d: "M115.5 180.5q.166-.925 1-1.5a95 95 0 0 0-18-1.5 2.43 2.43 0 0 1 .5-2 288 288 0 0 0 23.5 1.5z",
    style: {
      opacity: 1
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTuteclassLogo);
export default __webpack_public_path__ + "static/media/tuteclass-logo.6fd925371611a42ab0d2ab30e89ba31b.svg";
export { ForwardRef as ReactComponent };